'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dConsole$0024 from "./scala.-Console$.js";
var $p;
/** @constructor */
function $c_s_util_CommandLineParser$() {
}
export { $c_s_util_CommandLineParser$ as $c_s_util_CommandLineParser$ };
$p = $c_s_util_CommandLineParser$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_util_CommandLineParser$;
/** @constructor */
function $h_s_util_CommandLineParser$() {
}
export { $h_s_util_CommandLineParser$ as $h_s_util_CommandLineParser$ };
$h_s_util_CommandLineParser$.prototype = $p;
$p.XD = (function(err) {
  var where = ((err.Pg() === 0) ? "" : ((err.Pg() === 1) ? " after first argument" : ((" after " + err.Pg()) + " arguments")));
  var x = ((("Illegal command line" + where) + ": ") + err.YQ());
  $j_scala$002e$002dConsole$0024.$m_s_Console$().Cg().xu((x + "\n"));
});
var $d_s_util_CommandLineParser$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_util_CommandLineParser$, "scala.util.CommandLineParser$", ({
  wb: 1
}));
export { $d_s_util_CommandLineParser$ as $d_s_util_CommandLineParser$ };
var $n_s_util_CommandLineParser$;
function $m_s_util_CommandLineParser$() {
  if ((!$n_s_util_CommandLineParser$)) {
    $n_s_util_CommandLineParser$ = new $c_s_util_CommandLineParser$();
  }
  return $n_s_util_CommandLineParser$;
}
export { $m_s_util_CommandLineParser$ as $m_s_util_CommandLineParser$ };
